import { render, staticRenderFns } from "./InventoryTransactionDetails.vue?vue&type=template&id=391d9e96"
import script from "./InventoryTransactionDetails.vue?vue&type=script&lang=js"
export * from "./InventoryTransactionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./InventoryTransactionDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports